'use strict';
require('./CompanyNoticeService.js');
var moment = require("moment");

function dateIsEqual(a, b) {
  if(a instanceof Date && b instanceof Date) {
    return a.getTime() === b.getTime();
  }
  return false;
}

CompanyNoticeNewCtrl.$inject = [
  '$scope',
  '$stateParams',
  '$state',
  '$translate',
  'noticeCategories',
  'CompanyNoticeService',
  'growl'];
function CompanyNoticeNewCtrl(
  $scope,
  $stateParams,
  $state,
  $translate,
  noticeCategories,
  CompanyNoticeService,
  growl) {
    $scope.noticeCategories = noticeCategories;
    var endDateDefault = new Date();
        endDateDefault = moment(endDateDefault).add(1, 'year');

    var reminderAtDefault = new Date();
        reminderAtDefault.setDate(reminderAtDefault.getDate() + 30);

    var DEFAULT_NOTICE = {
      assignees:  [],
      createdAt: reminderAtDefault,
      enddate: endDateDefault,
      title: $scope.publication.name,
      createdBy: $scope.currentUser,
      description: '',
      reminderAt: reminderAtDefault,
      noticePeriod: $translate.instant('task.1-month'),
      publication: $scope.publication
    };
    

    DEFAULT_NOTICE.assignees.push({
      id:    $scope.currentUser.id,
      name:  $scope.currentUser.name,
      email: $scope.currentUser.email
    });

    $scope.notice = new CompanyNoticeService(angular.copy(DEFAULT_NOTICE));
    $scope.selectedMonth = 1;
 
    $scope.setNoticePeriod = function(m) {
      $scope.selectedMonth = m;
      $scope.notice.reminderAt = moment($scope.notice.enddate).subtract(m, (m === 1 ? 'month' : 'months'));
      if (m === 1) {
        $scope.notice.noticePeriod = $translate.instant('task.1-month');
      } else if(m === 2) {
        $scope.notice.noticePeriod = $translate.instant('task.2-months');
      } else if(m === 3) {
        $scope.notice.noticePeriod = $translate.instant('task.3-months');
      } else if(m === 6) {
        $scope.notice.noticePeriod = $translate.instant('task.6-months');
      } else if (m === 9) {
        $scope.notice.noticePeriod = $translate.instant('task.9-months');
      } else if (m === 12) {
        $scope.notice.noticePeriod = $translate.instant('task.12-months');
      }
    };

    $scope.checkReminderDate = function() {
      if($scope.notice.reminderAt >= $scope.notice.enddate) {
        $scope.setNoticePeriod(1);
      }
    };

    $scope.$watch("[notice.enddate,notice.reminderAt]", function(newValue, oldValue) {
      if(newValue[0] && oldValue[0] && !dateIsEqual(newValue[0], oldValue[0]) ||
        newValue[1] && oldValue[1] && !dateIsEqual(newValue[1], oldValue[1])) {
        $scope.checkReminderDate();
      }
      if(newValue[0] && oldValue[0] && !dateIsEqual(newValue[0], oldValue[0])){
        $scope.setNoticePeriod($scope.selectedMonth);
      }
    }, true);

    $scope.saveNotice = function() {
      $scope.notice.$save({companyId: $stateParams.companyId}, function(){
        growl.addSuccessMessage($translate.instant('notices.update-success'));
        $state.reload();
      }, function(){
        growl.addErrorMessage($translate.instant('notices.update-failure'));
      });
    };
}

angular.module('dokiv')
  .controller('CompanyNoticeNewCtrl', CompanyNoticeNewCtrl);



//////////////////
// WEBPACK FOOTER
// ./scripts/company/notices/CompanyNoticeNewCtrl.js
// module id = 364
// module chunks = 0